import styled from 'styled-components'

const FormContainer = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(props) => props.flex || 'column'};
  flex-wrap: ${(props) => (props.flex ? 'wrap' : 'nowrap')};
  margin: auto;
  padding: 0 30px 5%;
`
export default FormContainer



// WEBPACK FOOTER //
// ./src/components/containers/FormContainer.tsx